import React, { useState } from "react";
import SellerFarmerContactSupport from "./ContactSupport";
import SellerFarmerRaisedTicket from "./RaiseTicket";

const Support = () => {
  const [activeTab, setActiveTab] = useState("Contact Support");
  const tabs = ["Contact Support", "Raise Ticket"];

  const renderTabContent = () => {
    switch (activeTab) {
      case "Contact Support":
        return <SellerFarmerContactSupport />;
      case "Raise Ticket":
        return <SellerFarmerRaisedTicket />;
      default:
        return <SellerFarmerContactSupport />;
    }
  };

  return (
    <div className="buyer-layout">
      <div className="amtpl-tabs">
        <div className="content3">
          <main className="main-content">
            <div className="mb-3 main-tab">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`buttonclass ${
                    activeTab === tab ? "active" : "notactive"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="row">{renderTabContent()}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Support;
